import React from 'react';
import { InfoItemDd, InfoItemDt, InfoItemList } from '../../common';
import Icon from '../../../components/Icons';
import styled from 'styled-components/macro';

interface BasicInfoItemProps {
    onClick: () => void;
    label: string;
    isHovering: boolean;
    value: string | boolean | null | undefined;
    displayValue?: string;
    notSetValue?: string;
}

const BasicInfoItem = (
    {
        onClick,
        label,
        isHovering,
        value,
        displayValue,
        notSetValue,
    }: BasicInfoItemProps
) => {
    return (
        <InfoItemList onClick={onClick}>
            <InfoItemDt>{label}</InfoItemDt>
            <InfoItemDdRelative>
                {displayValue || value || (notSetValue && <NotSet>{notSetValue}</NotSet>)}
                {isHovering && (
                    <Edit>
                        <Icon fill="#1BC77E" icon="edit_pen" />
                        <span>Edit</span>
                    </Edit>
                )}
            </InfoItemDdRelative>
        </InfoItemList>
    );
};

export default BasicInfoItem;

const Edit = styled.div`
    display: inline-block;
    position: absolute;
    right: 0;
    & > span {
        font-weight: 700;
        font-size: 14px;
        color: #1bc77e;
        margin-left: 9px;
    }
`;

const InfoItemDdRelative = styled(InfoItemDd)`
    position: relative;
    cursor: pointer;
`;

const NotSet = styled.span`
    color: #c4c4c4;
    font-style: italic;
`;
